import { Button } from '@ordr-as/umami-react/button';
import classNames from 'classnames';
import { Dispatch, SetStateAction, useState } from 'react';
import { useIntl } from 'react-intl';
import { MenuItemVariantDto } from '../../../../../generated-api/models/MenuItemVariantDto';
import { TextInput } from '@ordr-as/umami-react/form';

interface Props {
  item: MenuItemVariantDto;
  customPrice: number | undefined;
  setCustomPrice: Dispatch<SetStateAction<number | undefined>>;
}

const GiftCardAmount = (props: Props) => {
  const { item, customPrice, setCustomPrice } = props;
  const intl = useIntl();
  const [textFieldIsHidden, setTextFieldIsHidden] = useState(true);
  const classes = classNames('rounded', 'border', 'border-grey-medium', 'hover:border-grey-dark');
  const selectedStyle: React.CSSProperties | undefined = {
    borderColor: '#7545FB',
    color: '#7545FB',
    fontWeight: 'bold',
  };

  const handleSelectAmount = (amount: number) => {
    setTextFieldIsHidden(true);
    setCustomPrice(amount);
  };

  const onShowTextField = () => {
    setCustomPrice(undefined);
    setTextFieldIsHidden(false);
  };

  const handleTextInputChange = (value: string) => {
    const parsedValue = parseFloat(value);
    const isNotvalid = isNaN(parsedValue) || parsedValue < 1;

    if (isNotvalid || parsedValue === item.price) {
      setCustomPrice(undefined);
      return;
    }

    setCustomPrice(parsedValue);
  };

  return (
    <>
      <div className="flex gap-1 mb-4">
        {[500, 750, 1000].map((amount) => (
          <Button
            key={amount}
            fullWidth
            className={classes}
            styleOverride={customPrice === amount && textFieldIsHidden ? selectedStyle : undefined}
            onClick={() => handleSelectAmount(amount)}
          >
            {amount}
          </Button>
        ))}
        <Button
          fullWidth
          className={classes}
          styleOverride={!textFieldIsHidden ? selectedStyle : undefined}
          onClick={() => onShowTextField()}
        >
          {intl.formatMessage({ id: 'generic.other' })}
        </Button>
      </div>
      {!textFieldIsHidden && (
        <TextInput
          fullWidth
          className="mb-4"
          label={intl.formatMessage({ id: 'generic.value' })}
          validationState={!customPrice ? undefined : 'invalid'}
          onChange={handleTextInputChange}
        />
      )}
      <span className="text-xs text-grey-dark">
        {intl.formatMessage({ id: 'items.giftCard.dialog.amount.validYears' }, { years: item.giftCardExpirationYears })}
      </span>
    </>
  );
};

export default GiftCardAmount;
